import React from 'react'
import SocialLinks from '../constants/socialLinks'

const footer = () => {
    return <footer className="footer">
    <div>
        <SocialLinks styleClass="footer-links"></SocialLinks>
    </div>
    </footer>
}

export default footer
